var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Transition", [
    _vm.show && _vm.newsletter
      ? _c(
          "section",
          { staticClass: "newsletter", attrs: { id: "rundschreiben" } },
          [
            _c("div", { staticClass: "header" }, [
              _c("div", [_c("h2", [_vm._v("Rundschreiben")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "close", on: { click: _vm.closeClicked } },
                [_c("CloseIcon")],
                1
              )
            ]),
            _vm._v(" "),
            _c("article", [
              _c("h3", [
                _c("div", { staticClass: "categoryContainer" }, [
                  _c("div", {
                    staticClass: "rsp2Icon",
                    domProps: { innerHTML: _vm._s(_vm.newsletter.icon) }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "rsp2Category" }, [
                    _vm._v(_vm._s(_vm.newsletter.category))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contentContainer" }, [
                _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "rsp2Title",
                      attrs: { href: _vm.newsletter.url }
                    },
                    [_vm._v(_vm._s(_vm.newsletter.title))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "rsp2Metadata" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\tVon\n\t\t\t\t\t\t" +
                        _vm._s(_vm._f("fullName")(_vm.newsletter.author)) +
                        "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm._f("prepend")(
                            _vm._f("formatDate")(_vm.newsletter.date),
                            " am"
                          )
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "rsp2Text" }, [
                    _vm._v(_vm._s(_vm.newsletter.teaser))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rsp2Action" }, [
                    _c(
                      "a",
                      {
                        staticClass: "riButton",
                        attrs: { href: _vm.newsletter.url }
                      },
                      [_vm._v("Weiterlesen")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "iconContainer" },
                  [_c("NewsletterIcon")],
                  1
                )
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }